import { SlidersHorizontal } from "lucide-react";
import { cn } from "@/utils/cn";

interface Props {
  title?: string;
  children: React.ReactNode;
  className?: string;
  end?: React.ReactNode;
}

/** Barra de filtros/ações interna das abas (mesmo visual do FilterBar principal). */
export function LocacoesSubToolbar({ title = "Filtros", children, className, end }: Props) {
  return (
    <div className={cn("rounded-xl border border-slate-200 bg-white px-5 py-4 shadow-card", className)}>
      <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <SlidersHorizontal className="h-3.5 w-3.5 text-brand-600" />
          <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">{title}</span>
        </div>
        {end}
      </div>
      {children}
    </div>
  );
}
